import { Routes } from '@angular/router';
import { xpoAuthCanMatch } from '@xpo-ltl/ngx-auth';

export const appRoutes: Routes = [
  {
    path: '',
    canMatch: [xpoAuthCanMatch()],
    loadChildren: () => import('./batch-framework/batch-framework.routes').then((m) => m.BATCH_FRAMEWORK_ROUTES),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
